export default "__VITE_ASSET__BfUJ8C$z__"